import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../common/types';
import { SMLContainer } from '../smartLinks/smlContainer/SMLContainer';
import { useSMLRouter } from '../../routing/sml/hooks';
import { SMLRoutes } from '../../routing/sml/SMLRoutes';
import { SMLPageHead } from './components/SMLPageHead/SMLPageHead';
import { BrowsePage } from './browse/BrowsePage';
import { useBrowsePage } from './browse/hooks/useBrowsePage';
import { BrowseCreditsPill } from './browse/phone/BrowseCreditsPill';
import { browseMessages } from './browse/browseMessages';

/**
 * Search (`/app/browse`, the old Browse), design browse-v2. Navigation v2 (design e 5e): not a menu
 * item; the command palette opens it with the typed text.
 */
const SMLBrowseHomeComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();
  const page = useBrowsePage();
  const { setCreditsSheetOpen } = page;

  // design navigation-v2 e 5e: the page is "Search", outside the menu groups.
  const breadcrumbs = useMemo(() => {
    return [
      {
        name: intl.formatMessage(browseMessages.pageTitle),
        onClick: () => router.push(SMLRoutes.browse),
      },
    ];
  }, [intl, router]);

  const header = (
    <SMLPageHead
      breadcrumbs={breadcrumbs}
      title={intl.formatMessage(browseMessages.pageTitle)}
      subtitle={intl.formatMessage(browseMessages.subtitle)}
    >
      <BrowseCreditsPill usage={page.usage} onOpen={() => setCreditsSheetOpen(true)} />
    </SMLPageHead>
  );

  return (
    <SMLContainer header={header}>
      <BrowsePage page={page} />
    </SMLContainer>
  );
};

export const SMLBrowseHome = TypedMemo(SMLBrowseHomeComponent);
